export function getExteriorGallery(media = []) {
  const gallery = (Array.isArray(media) ? media : []).filter(
    (item) => item?.collection_type === "exterior_image",
  );
  const card = gallery.find((item) => item.is_hero) || gallery[0];
  return card ? [card, ...gallery.filter((item) => item !== card)] : [];
}

export function getProductCover(media) {
  return getExteriorGallery(media)[0];
}

const IMAGE_EXTENSIONS = ["jpg", "jpeg", "png", "webp", "gif", "avif", "bmp"];

// Whether an uploaded file can be shown in the photo gallery. Documents such
// as PDFs cannot; a file with no recognisable extension is treated as a
// photo, which is what these uploads have always been.
export function isImageMedia(media) {
  const extensions = [media?.url, media?.display_name]
    .map((name) => String(name || "").split(/[?#]/)[0].match(/\.([a-z0-9]+)$/i))
    .filter(Boolean)
    .map((match) => match[1].toLowerCase());
  return (
    extensions.length === 0 ||
    extensions.some((extension) => IMAGE_EXTENSIONS.includes(extension))
  );
}
